import React,{ useState }  from "react";

const FeesEntry = () => {

    const [fees, setFees] = useState([
        { type: "Admission Fee", amount: 10000, paid: 5000, pending: 5000, current: "" },
        { type: "Tuition Fee", amount: 20000, paid: 10000, pending: 10000, current: "" },
        { type: "Exam Fee", amount: 5000, paid: 3000, pending: 2000, current: "" }
      ]);
    
      const handleInputChange = (index, value) => {
        const updatedFees = [...fees];
        updatedFees[index].current = value;
        setFees(updatedFees);
      };
    
      const totalCurrentAmount = fees.reduce((total, fee) => {
        const amount = parseFloat(fee.current) || 0;
        return total + amount;
      }, 0);

      const [firstName, setFirstName] = useState("");
      const [lastName, setLastName] = useState("");
      
  const handleSubmit = async () => {
    const payload = {
      student: {
        firstName,
        lastName
      },
      fees: fees.map(({ type, current }) => ({ type, current }))
    };

    try {
      const res = await fetch("https://school.agnisofterp.com/agni/testing/entry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const result = await res.json();
      alert(result.message || "Data saved successfully!");
    } catch (err) {
      console.error("Error:", err);
      alert("Failed to save data.");
    }
  };

  return (
    <div>
    <div className="row">
    <div className="col-25">
    <div class="coolinput">
<label for="input" class="text">First Name:</label>
<input type="text" placeholder="" name="STUDENTNAME"  value={firstName}
              onChange={(e) => setFirstName(e.target.value)} autoComplete="off" class="input"/>
</div>
    </div>
    <div className="col-75">
    <div class="coolinput">
<label for="input" class="text">Last Name:</label>
<input type="text" placeholder="" name="LASTNAME"  value={lastName}
              onChange={(e) => setLastName(e.target.value)} autoComplete="off" class="input"/>
</div>
    </div>
  </div>
  <div style={{ padding: "20px" }}>
      <h2>Fees Entry</h2>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={styles.th}>Type</th>
            <th style={styles.th}>Amount</th>
            <th style={styles.th}>Paid</th>
            <th style={styles.th}>Pending</th>
            <th style={styles.th}>Enter Current Amount</th>
          </tr>
        </thead>
        <tbody>
          {fees.map((fee, index) => (
            <tr key={index}>
              <td style={styles.td}>{fee.type}</td>
              <td style={styles.td}>{fee.amount}</td>
              <td style={styles.td}>{fee.paid}</td>
              <td style={styles.td}>{fee.pending}</td>
              <td style={styles.td}>
                {/* <input
                  type="text"
                  value={fee.current}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                  className="input"
                  style={{ width: "100%" }}
                /> */}
                 <div class="coolinput">
{/* <label for="input" class="text">Last Name:</label> */}
<input type="text" placeholder="" name="current"    value={fee.current}
                  onChange={(e) => handleInputChange(index, e.target.value)} autoComplete="off" class="input"/>
</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>


    </div>
    <div style={{ marginTop: "20px", fontSize: "18px", fontWeight: "bold" }}>
        Total Current Amount: ₹ {totalCurrentAmount.toFixed(2)}
      </div>
      <button onClick={handleSubmit} style={{ marginTop: "20px" }}>
          Save Fees Record
        </button>
  </div>
  );
};


const styles = {
    th: {
      border: "1px solid #ccc",
      padding: "10px",
      backgroundColor: "#f0f0f0",
      textAlign: "left"
    },
    td: {
      border: "1px solid #ccc",
      padding: "10px"
    }
  };
export default FeesEntry;